module.exports = __webpack_public_path__ + "media/images/athletes/3426-aeedc036b389c77349d44e91b885024f.png";